import styled from "styled-components";
import media from "constants/media";

export const TooltipButton = styled.button`
    display: flex;
    align-items: center;
    padding: 2px 7px 2px 2px;
`;

export const Icon = styled.img`
    max-width: ${({ maxWidth }) => maxWidth || "100%"};
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    margin: 0 auto;
    padding: 20px;

    background-color: var(--color-white);

    ${media.mdUp`
        display: block;
        height: auto;
        text-align: left;
        max-width: 580px;
    `}
`;

export const Top = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
`;

export const Main = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 0 20px 20px;

    ${media.mdUp`
        align-items: flex-start;
        justify-content: flex-start;
        height: auto;
    `}
`;

export const Title = styled.div`
    font-size: 24px;
    line-height: 30px;
    letter-spacing: 0;
`;

export const ImageContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 30px 0;
`;

export const Image = styled.img`
    width: auto;
    max-width: 350px;
`;
